import { GoogleAnalyticsMapperService, GoogleAnalyticsTrackingTag, TrackingData, TrackingProviders, TrackingSettings } from '@iot-platform/core';
import {
  TrackingEventCategories as DashboardsTrackingEventCategories,
  TrackingEventIds as DashboardsTrackingEventIds,
  TrackingEventNames as DashboardsTrackingEventNames
} from '@iot-platform/models/dashboards';
import { TrackingEventCategories, TrackingEventIds, TrackingEventLabels, TrackingEventNames } from '@iot-platform/models/i4b';

export const trackingSettings: TrackingSettings = {
  tags: {
    /**
     Asset template master view
     */
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_ASSET_TEMPLATE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_ASSET_TEMPLATE
      })
    },
    [TrackingEventIds.REFRESH_ASSET_TEMPLATE_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_ASSET_TEMPLATE_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_DETAILS_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ASSET_TEMPLATE_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_ASSET_TEMPLATE_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ASSET_TEMPLATE_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_ASSET_TEMPLATE_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_UPDATE_DIALOG_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_UPDATE_DIALOG
      })
    },
    [TrackingEventIds.UPDATE_ASSET_TEMPLATE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.UPDATE_ASSET_TEMPLATE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_DELETE_DIALOG_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ASSET_TEMPLATE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DELETE_ASSET_TEMPLATE
      })
    },
    /**
     Asset template overview
     */
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_ASSET_TEMPLATE_VARIABLE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_ASSET_TEMPLATE_VARIABLE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_CONFIGURE_DIALOG_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_CONFIGURE_DIALOG_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_ASSET_TEMPLATE_VARIABLE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.CONFIGURE_ASSET_TEMPLATE_VARIABLE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_DELETE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ASSET_TEMPLATE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.DELETE_ASSET_TEMPLATE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_UPDATE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_UPDATE_DIALOG
      })
    },
    [TrackingEventIds.UPDATE_ASSET_TEMPLATE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.UPDATE_ASSET_TEMPLATE
      })
    },
    [TrackingEventIds.OPEN_TEMPLATE_UPDATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_TEMPLATE_UPDATE_DIALOG
      })
    },
    [TrackingEventIds.UPDATE_TEMPLATE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.UPDATE_TEMPLATE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_PRODUCTS_CONFIGURE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_PRODUCTS_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_ASSET_TEMPLATE_PRODUCTS]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.CONFIGURE_ASSET_TEMPLATE_PRODUCTS
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_PRODUCTS_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_PRODUCTS_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ASSET_TEMPLATE_PRODUCTS]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.DELETE_ASSET_TEMPLATE_PRODUCTS
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_OPTIONAL_PROPERTIES_CONFIGURE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_OPTIONAL_PROPERTIES_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_ASSET_TEMPLATE_OPTIONAL_PROPERTIES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.CONFIGURE_ASSET_TEMPLATE_OPTIONAL_PROPERTIES
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_TAGS_CONFIGURE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_TAGS_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_ASSET_TEMPLATE_TAGS]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.CONFIGURE_ASSET_TEMPLATE_TAGS
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_FOLLOWED_VARIABLES_ADD_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_FOLLOWED_VARIABLES_ADD_DIALOG
      })
    },
    [TrackingEventIds.ADD_ASSET_TEMPLATE_FOLLOWED_VARIABLES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.ADD_ASSET_TEMPLATE_FOLLOWED_VARIABLES
      })
    },
    [TrackingEventIds.REMOVE_ASSET_TEMPLATE_FOLLOWED_VARIABLES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CONFIGURATION_ACTION,
        label: TrackingEventLabels.REMOVE_ASSET_TEMPLATE_FOLLOWED_VARIABLES
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_UPDATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_UPDATE_DIALOG
      })
    },
    [TrackingEventIds.UPDATE_ASSET_TEMPLATE_VARIABLE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.UPDATE_ASSET_TEMPLATE_VARIABLE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ASSET_TEMPLATE_VARIABLE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.DELETE_ASSET_TEMPLATE_VARIABLE
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_BULK_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_BULK_DELETE_DIALOG
      })
    },
    [TrackingEventIds.BULK_DELETE_ASSET_TEMPLATE_VARIABLE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_VARIABLES_ACTION,
        label: TrackingEventLabels.BULK_DELETE_ASSET_TEMPLATE_VARIABLE
      })
    },
    [TrackingEventIds.ASSET_TEMPLATE_OVERVIEW_TAB_CHANGE]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TAB_CHANGE,
        label: data.tabLabel as string
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.REFRESH_ASSET_TEMPLATE_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_ASSET_TEMPLATE_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_ASSET_TEMPLATE_VARIABLE_DETAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_TEMPLATE_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ASSET_TEMPLATE_VARIABLE_DETAIL_POPUP
      })
    },
    /**
     Users master view
     */
    [TrackingEventIds.OPEN_USER_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_USER_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_USER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_USER
      })
    },
    [TrackingEventIds.REFRESH_USER_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_USER_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_USER_FILTER_ENGINE]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.filterEngineOpened ? TrackingEventLabels.OPEN_FILTER_ENGINE : TrackingEventLabels.CLOSE_FILTER_ENGINE
      })
    },
    [TrackingEventIds.EXPORT_USER_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.EXPORT_USER_DATA
      })
    },
    [TrackingEventIds.OPEN_USER_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_USER_DETAILS_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_USER_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_USER_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_USER_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_USER_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.ENABLE_USER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.ENABLE_USER
      })
    },
    [TrackingEventIds.DISABLE_USER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DISABLE_USER
      })
    },
    [TrackingEventIds.RESEND_USER_VALIDATION_LINK]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.RESEND_USER_VALIDATION_LINK
      })
    },
    /**
     Users overview
     */
    [TrackingEventIds.REFRESH_USER_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_USER_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_USER_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_USER_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_USER_UPDATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_USER_UPDATE_DIALOG
      })
    },
    [TrackingEventIds.UPDATE_USER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.USER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.UPDATE_USER
      })
    },
    /**
     Po event rules master view
     */
    [TrackingEventIds.REFRESH_PO_EVENT_RULE_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_PO_EVENT_RULE_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_PO_EVENT_RULE_FILTER_ENGINE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_PO_EVENT_RULE_FILTER_ENGINE
      })
    },
    [TrackingEventIds.OPEN_PO_EVENT_RULE_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_PO_EVENT_RULE_DETAILS_POPUP
      })
    },
    [TrackingEventIds.OPEN_PO_EVENT_RULE_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_PO_EVENT_RULE_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_PO_EVENT_RULE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.OPEN_CONFIGURE_PO_EVENT_DIALOG_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.OPEN_CONFIGURE_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.CONFIGURE_PO_EVENT_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.CONFIGURE_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.OPEN_EDIT_PO_EVENT_DIALOG_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.OPEN_EDIT_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.EDIT_PO_EVENT_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.EDIT_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.OPEN_DELETE_PO_EVENT_DIALOG_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.OPEN_DELETE_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.DELETE_PO_EVENT_RULE_FROM_SHELL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.CALL_TO_ACTION,
        label: TrackingEventLabels.DELETE_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_GRID
      })
    },
    /**
     Po event rules overview
     */
    [TrackingEventIds.REFRESH_PO_EVENT_RULE_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_PO_EVENT_RULE_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_PO_EVENT_RULE_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_PO_EVENT_RULE_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_CONFIGURE_PO_EVENT_DIALOG_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_CONFIGURE_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.CONFIGURE_PO_EVENT_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.CONFIGURE_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.OPEN_EDIT_PO_EVENT_DIALOG_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_EDIT_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.EDIT_PO_EVENT_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.EDIT_PO_EVENT_RULE
      })
    },
    [TrackingEventIds.OPEN_DELETE_PO_EVENT_DIALOG_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_DELETE_PO_EVENT_DIALOG_RULE
      })
    },
    [TrackingEventIds.DELETE_PO_EVENT_RULE_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PO_EVENT_RULE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.DELETE_PO_EVENT_RULE
      })
    },
    /**
     product catalogs shell
     */
    [TrackingEventIds.OPEN_PRODUCT_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_PRODUCT_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_PRODUCT]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.CREATE_PRODUCT
      })
    },
    [TrackingEventIds.OPEN_PRODUCT_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_PRODUCT_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_PRODUCT]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.EDIT_PRODUCT
      })
    },
    [TrackingEventIds.OPEN_PRODUCT_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_PRODUCT_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_PRODUCT]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.DELETE_PRODUCT
      })
    },
    [TrackingEventIds.OPEN_CATALOG_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.DRAWER_ACTIONS,
        label: TrackingEventLabels.OPEN_CATALOG_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_CATALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.CREATE_CATALOG
      })
    },
    [TrackingEventIds.OPEN_CATALOG_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.DRAWER_ACTIONS,
        label: TrackingEventLabels.OPEN_CATALOG_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_CATALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.EDIT_CATALOG
      })
    },
    [TrackingEventIds.OPEN_CATALOG_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.DRAWER_ACTIONS,
        label: TrackingEventLabels.OPEN_CATALOG_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_CATALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.DELETE_CATALOG
      })
    },
    [TrackingEventIds.REFRESH_PRODUCT_CATALOGS_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_PRODUCT_CATALOGS_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_PRODUCT_CATALOGS_FILTER_ENGINE]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_PRODUCT_CATALOGS_FILTER_ENGINE
      })
    },
    [TrackingEventIds.EXPORT_PRODUCT_CATALOGS_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.PRODUCT_CATALOGS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.EXPORT_PRODUCT_CATALOGS_DATA
      })
    },
    /**
     escalation protocols shell
     */
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_DETAILS_POPUP
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_ESCALATION_PROTOCOL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_ESCALATION_PROTOCOL
      })
    },
    [TrackingEventIds.REFRESH_ESCALATION_PROTOCOLS_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_ESCALATION_PROTOCOLS_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOLS_FILTER_ENGINE]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.filterEngineOpened ? TrackingEventLabels.OPEN_FILTER_ENGINE : TrackingEventLabels.CLOSE_FILTER_ENGINE
      })
    },
    [TrackingEventIds.EXPORT_ESCALATION_PROTOCOLS_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.EXPORT_ESCALATION_PROTOCOLS_DATA
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_ESCALATION_PROTOCOL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.EDIT_ESCALATION_PROTOCOL
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ESCALATION_PROTOCOL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DELETE_ESCALATION_PROTOCOL
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_GRID
      })
    },
    /**
     * escalation protocols overview
     */
    [TrackingEventIds.REFRESH_ESCALATION_PROTOCOL_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_ESCALATION_PROTOCOL_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_EDIT_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_ESCALATION_PROTOCOL_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.EDIT_ESCALATION_PROTOCOL
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_DELETE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ESCALATION_PROTOCOL_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.DELETE_ESCALATION_PROTOCOL
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_LEVEL_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_LEVEL_DETAILS_POPUP
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_LEVEL_ADD_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_LEVEL_ADD_DIALOG
      })
    },
    [TrackingEventIds.ADD_ESCALATION_PROTOCOL_LEVEL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.ADD_ESCALATION_PROTOCOL_LEVEL
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_LEVEL_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.EDIT_ESCALATION_PROTOCOL_LEVEL
      })
    },
    [TrackingEventIds.EDIT_ESCALATION_PROTOCOL_LEVEL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.EDIT_ESCALATION_PROTOCOL_LEVEL
      })
    },
    [TrackingEventIds.EDIT_ESCALATION_PROTOCOL_LEVELS_ORDER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.EDIT_ESCALATION_PROTOCOL_LEVELS_ORDER
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_LEVEL_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_LEVEL_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_ESCALATION_PROTOCOL_LEVEL]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.DELETE_ESCALATION_PROTOCOL_LEVEL
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS
      })
    },
    [TrackingEventIds.OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS_MANAGE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS_MANAGE_DIALOG
      })
    },
    [TrackingEventIds.MANAGE_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ESCALATION_PROTOCOL_OVERVIEW,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.MANAGE_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS
      })
    },
    /**
     topics shell
     */
    [TrackingEventIds.OPEN_TOPIC_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_DETAILS_POPUP
      })
    },
    [TrackingEventIds.OPEN_TOPIC_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_TOPIC
      })
    },
    [TrackingEventIds.OPEN_TOPIC_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.EDIT_TOPIC
      })
    },
    [TrackingEventIds.OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG
      })
    },
    [TrackingEventIds.OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG
      })
    },
    [TrackingEventIds.OPEN_TOPIC_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DELETE_TOPIC
      })
    },
    [TrackingEventIds.NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_GRID
      })
    },
    [TrackingEventIds.REFRESH_TOPICS_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_TOPICS_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_TOPICS_FILTER_ENGINE]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.filterEngineOpened ? TrackingEventLabels.OPEN_FILTER_ENGINE : TrackingEventLabels.CLOSE_FILTER_ENGINE
      })
    },
    [TrackingEventIds.EXPORT_TOPICS_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.EXPORT_TOPICS_DATA
      })
    },
    [TrackingEventIds.OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG
      })
    },
    [TrackingEventIds.SUBSCRIBE_SELF_TO_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.SUBSCRIBE_SELF_TO_TOPIC
      })
    },
    [TrackingEventIds.UNSUBSCRIBE_SELF_FROM_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.UNSUBSCRIBE_SELF_FROM_TOPIC
      })
    },
    /**
     topics overview
     */
    [TrackingEventIds.REFRESH_TOPIC_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_TOPIC_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_TOPIC_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_TOPIC_EDIT_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_EDIT_DIALOG_FROM_OVERVIEW
      })
    },
    [TrackingEventIds.OPEN_TOPIC_CONFIGURE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_TOPIC]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.CONFIGURE_TOPIC
      })
    },
    [TrackingEventIds.OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG_FROM_OVERVIEW
      })
    },
    [TrackingEventIds.OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG_FROM_OVERVIEW
      })
    },
    [TrackingEventIds.OPEN_TOPIC_DELETE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_DELETE_DIALOG_FROM_OVERVIEW
      })
    },
    [TrackingEventIds.OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.TOPICS_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG_FROM_OVERVIEW
      })
    },
    /**
     email templates shell
     */
    [TrackingEventIds.REFRESH_EMAIL_TEMPLATES_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.EMAIL_TEMPLATES_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_EMAIL_TEMPLATES_SHELL_DATA
      })
    },
    /**
     iot platform dashboards
     */
    [DashboardsTrackingEventIds.OPEN_DASHBOARD_DATA_TABLE_DIALOG]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: DashboardsTrackingEventNames.DASHBOARDS_DATA_TABLE_DIALOG,
        category: DashboardsTrackingEventCategories.OPEN_DATA_TABLE_DIALOG,
        label: data.widgetTitle as string
      })
    },
    /**
     api keys shell
     */
    [TrackingEventIds.OPEN_API_KEY_DETAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_DETAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_API_KEY_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.TAB_ACTION,
        label: TrackingEventLabels.CREATE_API_KEY
      })
    },
    [TrackingEventIds.OPEN_API_KEY_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DELETE_API_KEY
      })
    },
    [TrackingEventIds.OPEN_API_KEY_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.EDIT_API_KEY
      })
    },
    [TrackingEventIds.ENABLE_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.ENABLE_API_KEY
      })
    },
    [TrackingEventIds.DISABLE_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DISABLE_API_KEY
      })
    },
    [TrackingEventIds.OPEN_API_KEY_RENEW_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_RENEW_DIALOG
      })
    },
    [TrackingEventIds.RENEW_API_KEY]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.RENEW_API_KEY
      })
    },
    [TrackingEventIds.OPEN_API_KEY_MANAGE_USAGE_PLAN_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_API_KEY_MANAGE_USAGE_PLAN_DIALOG
      })
    },
    [TrackingEventIds.MANAGE_API_KEY_USAGE_PLAN]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.API_KEYS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.MANAGE_API_KEY_USAGE_PLAN
      })
    },
    /**
     Data guard
     */
    [TrackingEventIds.TOGGLE_SITE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SITE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.dataGuardOpen ? TrackingEventLabels.OPEN_DATA_GUARD : TrackingEventLabels.CLOSE_DATA_GUARD
      })
    },
    [TrackingEventIds.NAVIGATE_TO_DEVICE_FROM_SITE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SITE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_DEVICE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ASSET_FROM_SITE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SITE_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_ASSET
      })
    },
    [TrackingEventIds.TOGGLE_ASSET_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.dataGuardOpen ? TrackingEventLabels.OPEN_DATA_GUARD : TrackingEventLabels.CLOSE_DATA_GUARD
      })
    },
    [TrackingEventIds.NAVIGATE_TO_DEVICE_FROM_ASSET_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_DEVICE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SITE_FROM_ASSET_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SITE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ASSET_FROM_ASSET_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.ASSET_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_ASSET
      })
    },
    [TrackingEventIds.TOGGLE_DEVICE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.DEVICES_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.dataGuardOpen ? TrackingEventLabels.OPEN_DATA_GUARD : TrackingEventLabels.CLOSE_DATA_GUARD
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SITE_FROM_DEVICE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.DEVICES_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SITE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_ASSET_FROM_DEVICE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.DEVICES_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_ASSET
      })
    },
    [TrackingEventIds.NAVIGATE_TO_DEVICE_FROM_DEVICE_DATA_GUARD]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.DEVICES_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_DEVICE
      })
    },
    /**
     Schedulers Shell
     */
    [TrackingEventIds.OPEN_SCHEDULER_DETAILS_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_DETAILS_POPUP
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_CREATE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_CREATE_DIALOG
      })
    },
    [TrackingEventIds.CREATE_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CREATE_SCHEDULER
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_EDIT_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.EDIT_SCHEDULER
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_DELETE_DIALOG]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_DELETE_DIALOG
      })
    },
    [TrackingEventIds.DELETE_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.DELETE_SCHEDULER
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SCHEDULER_OVERVIEW_PAGE_FROM_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.POPUP_ACTIONS,
        label: TrackingEventLabels.NAVIGATE_TO_SCHEDULER_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SCHEDULER_OVERVIEW_PAGE_FROM_GRID]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SCHEDULER_OVERVIEW_PAGE
      })
    },
    [TrackingEventIds.LAUNCH_SCHEDULER_NOW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.LAUNCH_SCHEDULER_NOW
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SCHEDULER_ADD_DEVICES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SCHEDULER_ADD_DEVICES
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SCHEDULER_REMOVE_DEVICES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SCHEDULER_REMOVE_DEVICES
      })
    },
    [TrackingEventIds.REFRESH_SCHEDULERS_SHELL_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_SCHEDULERS_SHELL_DATA
      })
    },
    [TrackingEventIds.OPEN_SCHEDULERS_FILTER_ENGINE]: {
      getGoogleTag: (data: TrackingData): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULERS_SHELL,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: data.filterEngineOpened ? TrackingEventLabels.OPEN_FILTER_ENGINE : TrackingEventLabels.CLOSE_FILTER_ENGINE
      })
    },
    /**
     Scheduler Overview
     */
    [TrackingEventIds.REFRESH_SCHEDULER_OVERVIEW_DATA]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.REFRESH_SCHEDULER_OVERVIEW_DATA
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_AUDIT_TRAIL_POPUP]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_AUDIT_TRAIL_POPUP
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_EDIT_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_EDIT_DIALOG
      })
    },
    [TrackingEventIds.EDIT_SCHEDULER_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.EDIT_SCHEDULER
      })
    },
    [TrackingEventIds.OPEN_SCHEDULER_DELETE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_DELETE_DIALOG
      })
    },

    [TrackingEventIds.OPEN_SCHEDULER_CONFIGURE_DIALOG_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.OPEN_SCHEDULER_CONFIGURE_DIALOG
      })
    },
    [TrackingEventIds.CONFIGURE_SCHEDULER_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.CONFIGURE_SCHEDULER
      })
    },
    [TrackingEventIds.LAUNCH_SCHEDULER_FROM_OVERVIEW]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.TAB_INFOS_ACTION,
        label: TrackingEventLabels.LAUNCH_SCHEDULER
      })
    },
    /**
     Scheduler Overview - Devices Tabs
     */
    [TrackingEventIds.OPEN_DEVICE_DETAILS_POPUP_FROM_SCHEDULER_DEVICES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.OPEN_DEVICE_DETAILS_POPUP
      })
    },
    [TrackingEventIds.NAVIGATE_TO_DEVICE_FROM_SCHEDULER_DEVICES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_DEVICE
      })
    },
    [TrackingEventIds.NAVIGATE_TO_SITE_FROM_SCHEDULER_DEVICES]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.NAVIGATE_TO_SITE
      })
    },
    [TrackingEventIds.ADD_SINGLE_DEVICE_TO_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.ADD_SINGLE_DEVICE
      })
    },
    [TrackingEventIds.ADD_BULK_DEVICES_TO_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.ADD_BULK_DEVICES
      })
    },
    [TrackingEventIds.REMOVE_SINGLE_DEVICE_FROM_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.REMOVE_SINGLE_DEVICE
      })
    },
    [TrackingEventIds.REMOVE_BULK_DEVICES_FROM_SCHEDULER]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.SCHEDULER_OVERVIEW,
        category: TrackingEventCategories.GRID_ACTION,
        label: TrackingEventLabels.REMOVE_BULK_DEVICES
      })
    }
  },
  providers: [{ provider: TrackingProviders.GoogleAnalytics, mapper: GoogleAnalyticsMapperService }]
};
